import * as React from 'react'
import 'react-dates/initialize'
import styled from 'styled-components'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { PostGallery } from './PostGallery'

interface IProps {
  post: interfaces.IPost
  likeable: boolean
}

export const PostDetailImages: React.FC<IProps> = ({ post, likeable }) => {
  return !post.post_images.length ? (
    <PostShowImage>
      <div className="PostShow_NoImage">No Image</div>
    </PostShowImage>
  ) : (
    <PostShowImages>
      {post.post_images.length === 1 ? (
        <PostShowImage>
          <img
            src={post.post_images[0].large_url || post.post_images[0].image_url}
            alt={post.post_images[0].description}
            {...({ fetchpriority: 'high' } as any)}
          />
        </PostShowImage>
      ) : (
        <PostGallery postImages={post.post_images} />
      )}
    </PostShowImages>
  )
}

const PostShowImages = styled.div`
  position: relative;
`

const PostShowImage = styled.div`
  margin-bottom: 4.8rem;
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    margin-bottom: 2.4rem;
  }

  > img {
    width: 100%;
    height: auto;
    object-fit: cover;
    aspect-ratio: 52 / 25;
    border-radius: 0.8rem;
    vertical-align: bottom;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      border-radius: 0;
    }
  }
`
const PostToggleLike = styled.div`
  position: absolute;
  bottom: 24px;
  right: 24px;
  width: 32px;
  height: 32px;
  color: ${constants.COLORS.white};
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    display: block;
  }
`
